import React from 'react';
import { IconEyeL } from '../../icons';
import { Button } from '../../components';
import css from './PreviewButton.css';

export default ({ onClickHandler = () => null }) => (
    <Button className={css.root} onClick={onClickHandler} type="button">
        <IconEyeL />
        <span>Vorschau ansehen</span>
    </Button>
);
